// extracted by mini-css-extract-plugin
module.exports = {"overflowFade":"_3JDWaI0","after":"_1GamL_e","readMore":"_3prPXPC","expanded":"_34ttsP3"};